// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import ArrowUpSvg from '@rsuite/icon-font/lib/direction/ArrowUp';
var ArrowUp = createSvgIcon({
  as: ArrowUpSvg,
  ariaLabel: 'arrow up',
  category: 'direction',
  displayName: 'ArrowUp'
});
export default ArrowUp;